/*
 * @Author: liuxuanxuan
 * @Date: 2021-07-23 14:43:02
 * @Last Modified by: liuxuanxuan
 * @Last Modified time: 2021-12-13 16:33:18
 * api接口的统一出口
 */

import axios from '@/request/http';
import qs from 'qs';

const API = {
  //绑定手机号
  bindePhone(params) {
    return axios.post(`/pc/bind`, params);
  },
  codeImage(params) {
    return axios.get(`/code/image`, params);
  },
  //登录注册
  login(params) {
    return axios.post(`/pc/login`, params);
  },
  //退出登录
  logOut(params) {
    return axios.post(`/pc/logout`, params);
  },
  //获取短信验证码
  sms(params) {
    return axios.post(`/sms`, params);
  },
  //签到
  userSign(params) {
    return axios.post(`/pc/user/sign`, params);
  },
  //首页顶部栏目
  channelList(params) {
    return axios.post(`/channels`, params);
  },
  //首页签到热榜
  signHotList(params) {
    return axios.post(`/pc/index/sign-hot`, params);
  },
  //栏目详情
  channelDetail(params) {
    return axios.post(`/pc/index/channel/detail`, params);
  },
  //活动列表
  activityList(params) {
    return axios.post(`/pc/index/activity/list`, params);
  },
  //活动详情
  activityDetail(params) {
    return axios.post(`/pc/index/activity/detail`, params);
  },
  //活动报名列表
  activityEnrollList(params) {
    return axios.post(`/pc/activity/enroll-list`, params);
  },
  //文章列表
  articleList(params) {
    return axios.post(`/pc/index/article/list`, params);
  },
  //文章详情
  articleDetail(params) {
    return axios.post(`/pc/index/article/detail`, params);
  },
  //关注
  attentionHandle(params) {
    return axios.post(`/pc/attention/handle`, params);
  },
  //删除文章
  articleDel(params) {
    return axios.post(`/pc/article/del-article`, params);
  },
  //发文章\发视频
  addPosts(params) {
    return axios.post(`/pc/article/add`, params);
  },
  //编辑文章
  editPosts(params) {
    return axios.post(`/pc/article/edit`, params);
  },
  //发活动
  addActivity(params) {
    return axios.post(`/pc/activity/add`, params);
  },
  //个人中心
  //我发布的文章、视频列表
  myArticleList(params) {
    return axios.post(`/pc/user/my-article`, params);
  },
  //我发布的活动列表
  myActivityList(params) {
    return axios.post(`/pc/user/my-activity`, params);
  },
  //我参与的活动列表
  myJoinActivityList(params) {
    return axios.post(`/pc/user/my-join-activity`, params);
  },
  //我的收藏
  myCollectList(params) {
    return axios.post(`/pc/user/my-collect`, params);
  },
  //我的赞
  myLikeList(params) {
    return axios.post(`/pc/user/my-like`, params);
  },
  //浏览记录
  myVisitList(params) {
    return axios.post(`/pc/user/my-visit`, params);
  },
  //我关注的列表
  myAttentionList(params) {
    return axios.post(`/pc/user/my-attention`, params);
  },
  //我的粉丝列表
  myFansList(params) {
    return axios.post(`/pc/user/my-fans`, params);
  },
  //兴趣爱好
  interests(params) {
    return axios.post(`/interests`, params);
  },
  //我的个人详情
  userMyDetail(params) {
    return axios.post(`/pc/user/my-detail`, params);
  },
  //用户修改基础信息
  userUpdate(params) {
    return axios.post(`/pc/user/update`, params);
  },
  //用户修改头像
  userUpdateIcon(params) {
    return axios.post(`/pc/user/update/icon`, params);
  },
  //用户修改手机号
  userUpdatePhone(params) {
    return axios.post(`/pc/user/update/phone`, params);
  },
  //他人详情
  userDetail(params) {
    return axios.post(`/pc/index/user/detail`, params);
  },
  //他人文章视频列表
  articleTaList(params) {
    return axios.post(`/pc/index/article/ta-list`, params);
  },
  //他人活动列表
  activityTaList(params) {
    return axios.post(`/pc/index/activity/ta-list`, params);
  },
  //活动报名
  activityEnroll(params) {
    return axios.post(`/pc/activity/enroll`, params);
  },
  //活动审核
  activityEnrollCheck(params) {
    return axios.post(`/pc/activity/enroll-check`, params);
  },
  //添加评论
  discussAdd(params) {
    return axios.post(`/pc/discuss/add`, params);
  },
  //评论列表
  discussList(params) {
    return axios.post(`/pc/discuss/list`, params);
  },
  //评论列表
  appDiscussList(params) {
    return axios.post(`/app/discuss/list`, params);
  },
  //举报
  reportAdd(params) {
    return axios.post(`/pc/report/add`, params);
  },
  //app  文章详情
  mPostsDatail(params) {
    return axios.post(`/app/index/article/detail`, params);
  },
  newPostsDatail(params) {
    return axios.post(`/app/xhn/c3/news/detail`, params);
  },
  //app  活动详情
  mActivetyDatail(params) {
    return axios.post(`/app/index/activity/detail`, params);
  },
  //app  签到列表
  mSignHotList(params) {
    return axios.post(`/app/index/sign-hot`, params);
  },
  //消息列表
  myMessageList(params) {
    return axios.post(`/pc/user/my-message`, params);
  },
  //常见问题列表
  questionList(params) {
    return axios.post(`/pc/question/list`, params);
  },
  //反馈问题
  questionAdd(params) {
    return axios.post(`/pc/question/add`, params);
  },
  //收藏
  collectHandle(params) {
    return axios.post(`/pc/collect/handle`, params);
  },
  //点赞
  likeHandle(params) {
    return axios.post(`/pc/like/handle`, params);
  },
  //search
  search(params) {
    return axios.post(`/pc/index/search`, params);
  },
  //消息已读
  readMessage(params) {
    return axios.post(`/pc/user/read-message`, params);
  },
  //协议
  getAgreement(params) {
    return axios.post(`/get-agreement`, params);
  },
  //上传
  uploadImg(params) {
    return axios.post(`/upload/images`, params, {headers: {'Content-Type': 'multipart/form-data'}});
  },
  // 多张图片本地化
  uploadImgsLocal(params){
    // console.log(params);
    return axios.post(`/upload/images/local`,params)
  },
  // 单个图片本地化
  uploadImgLocal(params){
    // console.log(params);
    return axios.post(`/upload/image/local`,params)
  },
  //话题
  topics(params) {
    return axios.post(`/topics`, params);
  },
  //话题
  topicDetail(params) {
    return axios.post(`/pc/index/topic/detail`, params);
  },
  //app话题
  topicAppDetail(params) {
    return axios.post(`/app/index/topic/detail`, params);
  },
  //app  文章列表
  mActivetyList(params) {
    return axios.post(`/app/index/article/list`, params);
  },
  //app  打赏列表
  mDonateList(params) {
    return axios.post(`/app/index/donate/list`, params);
  },
  //pc  打赏列表
  donateList(params) {
    return axios.post(`/pc/index/donate/list`, params);
  },
  //pc  打赏
  articleDonate(params) {
    return axios.post(`/pc/article/donate`, params);
  },
  //app  新闻详情
  c3NewsDetail(params) {
    return axios.post(`/app/c3/news/detail`, params);
  },
  //app  新闻详情推荐阅读
  c3NewsRecommend(params) {
    return axios.post(`/app/xhn/c3/news/recommend`, params);
  },
  //app 投票
  voteHandle(params) {
    return axios.post(`/app/vote/handle`, params);
  },
  //pc投票
  voteHandlePC(params) {
    return axios.post(`/pc/vote/handle`, params);
  },
  //wap 登录、登录即注册
  wapLogin(params) {
    return axios.post(`/wap/login`, params);
  },
  // wap 退出
  wapLogout(params) {
    return axios.post(`/wap/logout`, params);
  },
  // wap 专题
  subjectList(params) {
    return axios.post(`/app/c3/subject/list`, params);
  },
   // wap 新闻列表
   subNewsList(params) {
    return axios.post(`/app/c3/subject/news/list`, params);
  },
    // wap 新闻画卷专题广告
    recommendOther(params) {
      return axios.post(`/app/xhn/c3/news/recommend/other`, params);
    },
}


// 导出接口
export default API;



// WEBPACK FOOTER //
// ./src/request/api.js